import { useState } from 'react';
import Lineage from 'components/lineage/Lineage';

export default function LineageWrapper({ props }: { props: any }) {
    const [showLineage, setShowLineage] = useState(true);

    const hideLineage = () => {
        setShowLineage(false);
    };

    return <Lineage showLineage={showLineage} onHide={hideLineage} id={String(props.id)} type={String(props.type)} />;
}
